import { render, staticRenderFns } from "./CoachChampionshipRow.vue?vue&type=template&id=6a3f38dd&"
import script from "./CoachChampionshipRow.vue?vue&type=script&lang=ts&"
export * from "./CoachChampionshipRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports